module.exports = __webpack_public_path__ + "img/40_38_040_531.b2f60f5f.jpg";